<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.exportacao"
        ref="RkmDataTable"
        sort-by="unidade"
    >
        <template v-slot:cell(actions)="row">
            <rkm-button
                :disabled="!!row.item.encaminhado"
                @click="handleEncaminhar(row.item)"
                authorize="update-bpa-exportacao"
                color="primary"
                small
                title="Encaminhar"
            >
                <rkm-icon icon="share" />
            </rkm-button>

            <rkm-button
                @click="handleDownload(row.item)"
                color="primary"
                small
                title="Download"
            >
                <rkm-icon icon="download" />
            </rkm-button>

            <rkm-button
                :disabled="!!row.item.encaminhado"
                @click="handleDestroy(row.item)"
                authorize="destroy-bpa-exportacao"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {error, formats, repository, stringCase} from '@/mixins'

export default {
    created() {
        this.repositories.exportacao = this.getConectaSusRepository('bpa.exportacao')
    },
    data() {
        return {
            fields: [
                {
                    name: 'dataHoraExportacao',
                    key: 'dataHoraExportacao',
                    label: 'Data / Hora da exportação',
                    sortable: true,
                    formatter: value => this.formatDateTime(value),
                    filterByFormatted: true,
                    fixed: true,
                },
                { name: 'cadastro_unidade.nome_fantasia', key: 'unidade', label: 'Unidade', searchable: true, sortable: true },
                { name: 'competencia.valor', key: 'competencia', label: 'Competência', searchable: true, sortable: true },
                { key: 'financiamentos', label: 'Financiamentos', class: 'col-6' },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ],
            repositories: {},
        }
    },
    methods: {
        refresh() {

            this.$refs.RkmDataTable.refresh()
        },
        handleEncaminhar(item) {
            const request = { encaminhado: true }

            this.repositories.exportacao.update(item.id, this.camelObjectKeysToSnakeRecursive(request))
                .then(() => {
                    this.$refs.RkmDataTable.refresh()
                    this.showSaveNotification()
                })
                .catch(this.handleError)
        },
        handleDownload(item) {
            this.repositories.exportacao.download(item.id)
                .then(response => {
                    const file = response.headers['content-disposition'].split('filename=')[1]
                    const blob = new Blob([response.data])
                    const link = document.createElement('a')

                    link.href = URL.createObjectURL(blob)
                    link.download = file
                    link.click()
                })
                .catch(this.handleError)
        },
        handleDestroy(item) {
            const destroy = () => this.repositories.exportacao.destroy(item.id)
                .then(() => {
                    this.$refs.RkmDataTable.refresh()
                })

            this.showDeleteConfirmation('Deseja realmente excluir a exportação?', destroy)
        },
    },
    mixins: [ error, formats, repository, stringCase],
}
</script>